import { useEffect, useState } from "react";
export var useDebounce = function (value, delay) {
    var _a = useState(value), debouncedValue = _a[0], setDebouncedValue = _a[1];
    useEffect(function () {
        var timeout = setTimeout(function () {
            setDebouncedValue(value);
        }, delay);
        return function () {
            clearTimeout(timeout);
        };
    }, [value, delay]);
    return debouncedValue;
};
